<template>
  <div v-if="errors.length > 0" class="errors">
    <div v-for="(error, key) in errors" :key="key" class="error">
      {{ error }}
    </div>
  </div>
  <div v-if="visible" class="services__wrapper">
    <div class="service__title">Подать заявление на выплату по риску "Дожитие"</div>
    <div class="service__content">
      <div class="contract-selector">
        <div class="dropdown">
          <input v-model="chosenElement" type="text" id="contract-select" placeholder="Выберите договор"
                 @click="toggleDropdown()">
          <img v-if="!dropdownIsOpened" src="@/profile/assets/icons/arrow-bottom.svg" alt="arrow-bottom"
               class="dropdown__arrow" @click="toggleDropdown()">
          <img v-else-if="dropdownIsOpened" src="@/profile/assets/icons/arrow-top.svg" alt="arrow-top"
               class="dropdown__arrow" @click="toggleDropdown()">
          <div v-if="dropdownIsOpened" class="dropdown-content">
            <div v-for="contract in contracts" :key="contract.id" class="dropdown-item"
                 @mousedown="contractClickHandle(contract)">
              Договор {{ contract.name }} от {{ contract.date }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <MakcDialogComponent
      :title="'К сожалению, Ваши документы не могут быть отправлены'"
      :text="'Выплаты по риску \'Дожитие\' производится только Застрахованному лицу. Для получения выплаты в Страховую компанию должен обратиться Застрахованный'"
      btn_text="OK"
      v-model:show="modal_show"
    ></MakcDialogComponent>
  </div>
</template>

<script>
import axios from "axios";
import { url } from "@/profile/composables/url";
import MakcDialogComponent from "@/profile/components/UI/MakcDialogComponent";

export default {
  name: "LivingStatementListComponent",
  components: { MakcDialogComponent },
  data: () => {
    return {
      contracts: [],
      modal_show: false,
      visible: false,
      errors: [],
      chosenElement: null,
      dropdownIsOpened: false
    };
  },
  emits: ["contractClickHandle", "loadingIsCompleted"],
  methods: {
    contractClickHandle(contract) {
      this.chosenElement = `Договор ${contract.name} от ${contract.date}`;
      this.$emit("contractClickHandle", contract, "lsl");
      this.dropdownIsOpened = false;
    },
    toggleDropdown() {
      this.dropdownIsOpened = !this.dropdownIsOpened;
    },
    async fetchData(params) {
      try {
        const { data } = await axios.post(url, { params: params });
        this.contracts = data.result;
        if (data.result.length > 0) {
          this.visible = true;
        }
        this.$emit("loadingIsCompleted", data.result);
      } catch (e) {
        this.errors.push(e);
      }
    }
  },
  mounted() {
    let params = {
      command: "living_contracts_list",
      token: this.$myApp.token.get()
    };
    this.fetchData(params);
  }
};
</script>

<style scoped></style>